import {
	MarketingCampaignAdmin,
	parseCampaignContent,
} from "../../entities/marketing-campaign-admin.model";
import { TableTemplateButtons } from "../../components/table/table-template.model";

/**
 * One row in the marketing campaigns list. The schedule (campaign_launch) and
 * message count are derived from the parsed YAML content.
 */
export class MarketingCampaignRow {
	id: number;
	name: string;
	schedule: string;
	messagesCount: number;
	actionsTemplate: TableTemplateButtons;

	constructor(params: {
		campaign: MarketingCampaignAdmin;
		onEdit: (campaignId: number) => void;
		onDelete: (campaignId: number, name: string) => void;
	}) {
		const { campaign, onEdit, onDelete } = params;
		const config = parseCampaignContent(campaign.content);
		this.id = campaign.id as number;
		this.name = campaign.name;
		this.schedule = config.campaign_launch ? String(config.campaign_launch) : "—";
		this.messagesCount = config.messages?.length ?? 0;
		this.actionsTemplate = [
			{
				id: "btnEdit",
				icon: "pi pi-pencil",
				className: "p-button-text neutral",
				onClick: () => onEdit(campaign.id as number),
			},
			{
				id: "btnDelete",
				icon: "pi pi-trash",
				className: "p-button-text neutral",
				onClick: () => onDelete(campaign.id as number, campaign.name),
			},
		];
	}
}
